import { IonButton, IonIcon, IonListHeader } from '@ionic/react';
import ExploreListItem from 'components/listElements/ExploreListItem/ExploreListItem';
import { ExploreElement } from 'models/ExploreElementModel/ExploreElementModel';
import { FunctionComponent, useState } from 'react';
import { Trans } from 'react-i18next';
import Icon from '../../../components/icons/Icon';

interface ContestSectionProps {
  contests: ExploreElement[];
  activeTab: number;
  openContestModal: (contest: ExploreElement) => void;
}

const ContestSection: FunctionComponent<ContestSectionProps> = (
  props: ContestSectionProps
) => {
  const [visibleContestsCount, setVisibleContestsCount] = useState(3);
  const { contests, activeTab, openContestModal } = props;

  if (contests.length === 0) {
    return null; // Return null if there are no contests to display
  }

  return (
    <div
      className="section-container"
      style={{ marginBottom: '16px', marginRight: '16px' }}
    >
      {/* Contests Header */}
      <IonListHeader style={{ paddingLeft: '0', marginBottom: '8px' }}>
        {
          <Icon
            name="WinnerSidedHairIcon"
            size="default"
            color="--ion-color-primary"
            marginLeft={8}
            marginRight={4}
            style={{ backgroundColor: 'transparent' }}
          />
        }
        <Trans i18nKey="CONTESTS">Contests</Trans>
        <span
          style={{
            marginLeft: '8px',
            fontSize: '12px',
            color: 'var(--ion-color-primary)',
          }}
        >
          ({contests.length})
        </span>
      </IonListHeader>
      <div className="items-container">
        {contests.slice(0, visibleContestsCount).map((item, idx) => (
          <div key={`${item.id}_${idx}`} style={{ marginBottom: '4px' }}>
            <ExploreListItem
              item={item}
              isFriend={activeTab === 1}
              onOpenContestModal={openContestModal}
            />
          </div>
        ))}

        {contests.length > visibleContestsCount && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '0',
              paddingTop: '0',
            }}
          >
            {/* Contests Load More Button */}
            <IonButton
              fill="clear"
              size="small"
              className="load-more-button contests"
              onClick={() => setVisibleContestsCount((prev) => prev + 3)}
              style={{
                '--border-color': 'transparent',
                '--color': 'var(--ion-color-warning)',
                '--background': 'transparent',
                '--background-hover': 'var(--ion-color-warning-tint)',
                '--color-hover': 'var(--ion-color-warning-contrast)',
                boxShadow: 'none',
              }}
            >
              <Icon
                name="WinnerSidedHairIcon"
                size="small"
                color="--ion-color-secondary"
                marginRight={4}
                style={{ backgroundColor: 'transparent' }}
              />
              <Trans
                i18nKey="LOAD_MORE_CONTESTS"
                values={{
                  count: contests.length - visibleContestsCount,
                }}
              >
                {contests.length - visibleContestsCount} weitere Contests
                anzeigen
              </Trans>
            </IonButton>
          </div>
        )}
      </div>
    </div>
  );
};
export default ContestSection;
